import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { Menu } from '../../entities/Menu';
import { ActiveMenuService } from '../../services/active-menu.service';
import { SideMenuFileService } from '../../../services/side-menu-file.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit, OnDestroy {
    @ViewChild('sidenav') sidenav?: MatSidenav;
    @Output() isExpandedFlag = new EventEmitter();
    @Output() showResponsiveFlag = new EventEmitter();
    routerEventSubscription: Subscription | undefined;

    isExpanded = true;
    showSubmenu = false;
    showResponsive = false;
    showSubSubMenu = false;
    currentUrl!: string;

    menuList: Menu[] = [];

    constructor(
        private breakpointObserver: BreakpointObserver,
        private router: Router,
        private activeMenuService: ActiveMenuService,
        private sideMenuFileService: SideMenuFileService
    ) {}

    ngOnInit(): void {
        this.sideMenu();
        this.routerEventSubscription = this.router.events.subscribe(val => {
            if (val instanceof NavigationEnd) {
                this.setActiveMenuUrl(this.router.url);
            }
        });
        this.breakpointObserver.observe(['(min-width: 0px) and (max-width: 767px)']).subscribe((result: BreakpointState) => {
            if (result.matches) {
                this.isExpanded = true;
            }
        });
        this.breakpointObserver.observe(['(min-width: 768px) and (max-width: 991px)']).subscribe((result: BreakpointState) => {
            if (result.matches) {
                this.isExpanded = false;
            }
        });
        this.breakpointObserver.observe(['(min-width: 992px)']).subscribe((result: BreakpointState) => {
            if (result.matches) {
                this.isExpanded = true;
                this.showResponsive = true;
            }
        });
    }

    setActiveMenuUrl(url: string) {
        const routerList = url.split('/');
        this.activeParentMenu(routerList[1]);
    }

    sideMenu() {
        this.sideMenuFileService.getSideMenuFileJson().then(response => {
            this.menuList = response;
            this.activeMenuService.activeMenu.subscribe(() => {
                this.setActiveMenuUrl(this.router.url);
            });
        });
    }

    activeParentMenu(activeMenu: string) {
        this.menuList.forEach((menuData: Menu) => {
            if (menuData.url_path === activeMenu) {
                menuData.active = true;
            } else {
                menuData.active = false;
            }
            if (menuData.children) {
                menuData.children.forEach((element: Menu) => {
                    if (element.url_path === activeMenu) {
                        element.active = true;
                        menuData.active = true;
                    } else {
                        element.active = false;
                    }
                });
            }
        });
    }

    openMenu(menu: Menu, submenu?: Menu) {
        this.breakpointObserver.observe(['(min-width: 0) and (max-width: 767px)']).subscribe((result: BreakpointState) => {
            if (result.matches) {
                this.isExpanded = true;
            }
        });
        if (!submenu) {
            this.router.navigate([menu.url_path]);
        } else {
            this.router.navigate([submenu.url_path]);
        }
        this.activeParentMenu(menu.url_path);
    }

    mouseenter() {
        this.breakpointObserver.observe(['(min-width: 0) and (max-width: 767px)']).subscribe((result: BreakpointState) => {
            if (result.matches) {
                this.isExpanded = false;
            }
        });
        this.breakpointObserver.observe(['(min-width: 768px) and (max-width: 991px)']).subscribe((result: BreakpointState) => {
            if (result.matches) {
                this.isExpanded = true;
            }
        });
        this.breakpointObserver.observe(['(min-width: 992px)']).subscribe((result: BreakpointState) => {
            if (result.matches) {
                this.isExpanded = true;
            }
        });
    }

    mouseleave() {
        this.breakpointObserver.observe(['(min-width: 0) and (max-width: 767px)']).subscribe((result: BreakpointState) => {
            if (result.matches && !this.showResponsive) {
                this.isExpanded = false;
            }
        });
        this.breakpointObserver.observe(['(min-width: 768px) and (max-width: 991px)']).subscribe((result: BreakpointState) => {
            if (result.matches && !this.showResponsive) {
                this.isExpanded = false;
            }
        });
        this.breakpointObserver.observe(['(min-width: 992px)']).subscribe((result: BreakpointState) => {
            if (result.matches && !this.showResponsive) {
                this.isExpanded = false;
            }
        });
    }

    responsiveFlag(event: boolean) {
        this.showResponsive = event;
    }

    expandedFlag(event: boolean) {
        this.isExpanded = event;
    }

    ngOnDestroy(): void {
        this.routerEventSubscription?.unsubscribe();
    }
}
